import { LiteBox } from "../../../components/lite/LiteBox";
import useStyles from "../styles";
import { DotIcon } from "../../../components/icons/DotIcon";
import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";

const headerLabels = ["product", "domain-header-general", "simulation-counterparty"];

interface ISimulationTableHeaderProps {
	title?: string;
}

export const SimulationTableHeader = (props: ISimulationTableHeaderProps) => {
	const { t } = useTranslation();
	const { w600 } = useStyles();
	if (!props.title) {
		return null;
	}

	const labels = JSON.parse(props.title);

	return (
		<LiteBox display="flex" padding="32px 32px 0px 32px">
			{labels.map((label: string, index: number) => (
				<LiteBox display="flex">
					<Typography className={w600}>{`${t(headerLabels[index])}:`}</Typography>
					<Typography style={{ paddingLeft: 4 }}>{label}</Typography>
					{index !== labels.length - 1 && <DotIcon />}
				</LiteBox>
			))}
		</LiteBox>
	);
};
